module.exports = __webpack_public_path__ + "static/media/fp-top1.29429636.jpg";